module.exports = __webpack_public_path__ + "img/ipc_intro1.90febbb7.png";